"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ReconnectButton = exports.ImportButton = exports.INITIAL_VALUES = exports.baseSchema = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var yup = _interopRequireWildcard(require("yup"));

var _classnames = _interopRequireDefault(require("classnames"));

var _i18next = _interopRequireDefault(require("i18next"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _mapValues = _interopRequireDefault(require("lodash/mapValues"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _get = _interopRequireDefault(require("lodash/get"));

var _formik = require("formik");

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));

var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));

var _Input = _interopRequireDefault(require("../Input"));

var _Select = _interopRequireDefault(require("../Select"));

var _Button = _interopRequireDefault(require("../Button"));

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));

var _FormErrorMessage = _interopRequireDefault(require("../FormErrorMessage"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var baseSchema = {
  emailAddress: yup.string().trim().email(_i18next["default"].t('retrofit.imap.emailAddress.error.invalid')).required(_i18next["default"].t('retrofit.imap.error.required')),
  password: yup.string().trim().required(_i18next["default"].t('retrofit.imap.error.required'))
};
exports.baseSchema = baseSchema;
var INITIAL_VALUES = {
  emailAddress: '',
  username: '',
  password: '',
  imapHost: '',
  imapPort: 993,
  imapEncryption: 0,
  smtpHost: '',
  smtpPort: 465,
  smtpEncryption: 0
};
exports.INITIAL_VALUES = INITIAL_VALUES;

var IMAPForm = function IMAPForm(_ref) {
  var title = _ref.title,
      isLoading = _ref.isLoading,
      _ref$disabledFields = _ref.disabledFields,
      disabledFields = _ref$disabledFields === void 0 ? {} : _ref$disabledFields,
      _ref$initialValues = _ref.initialValues,
      initialValues = _ref$initialValues === void 0 ? INITIAL_VALUES : _ref$initialValues,
      onSubmit = _ref.onSubmit,
      action = _ref.action,
      _ref$advanced = _ref.advanced,
      advanced = _ref$advanced === void 0 ? false : _ref$advanced,
      encryptionOptions = _ref.encryptionOptions,
      _ref$advancedConfig = _ref.advancedConfig,
      advancedConfig = _ref$advancedConfig === void 0 ? {} : _ref$advancedConfig;
  var formik = (0, _react.useRef)(null);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var advancedSchema = {
    username: yup.string(),
    imapHost: yup.string().trim().required(t('retrofit.imap.error.required')),
    imapPort: yup.number().required(t('retrofit.imap.error.required')),
    imapEncryption: yup.number().required(t('retrofit.imap.error.required')),
    smtpHost: yup.string().trim().required(t('retrofit.imap.error.required')),
    smtpPort: yup.number().required(t('retrofit.imap.error.required')),
    smtpEncryption: yup.number().required(t('retrofit.imap.error.required'))
  };
  (0, _react.useEffect)(function () {
    var formikRef = formik.current;

    if (formikRef) {
      var state = formikRef.state;

      if (!(0, _isEmpty["default"])(advancedConfig)) {
        var nextValues = fixValueType(_objectSpread(_objectSpread({}, state.values), advancedConfig));
        formikRef.setValues(nextValues);
        formikRef.runValidations();
      }
    }
  }, [(0, _isEmpty["default"])(advancedConfig)]);

  function handleOnSubmit(values) {
    Promise.resolve(onSubmit(fixValueType(values)))["catch"](function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          field = _ref2.field,
          message = _ref2.message;

      var formikRef = formik.current;

      if (formikRef && field && message) {
        formikRef.setFieldError(field, message);
      }
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    ref: formik,
    enableReinitialize: true,
    validationSchema: yup.object().shape(_objectSpread(_objectSpread({}, baseSchema), advanced ? advancedSchema : {})),
    initialValues: fixValueType(initialValues),
    onSubmit: handleOnSubmit
  }, function (_ref3) {
    var isValid = _ref3.isValid;
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      className: "max-w-screen-md"
    }, /*#__PURE__*/_react["default"].createElement("h1", {
      className: "font-bold text-5xl text-dark mb-5 px-5"
    }, title), /*#__PURE__*/_react["default"].createElement(Section, {
      noborder: true
    }, /*#__PURE__*/_react["default"].createElement(BaseForm, {
      isLoading: isLoading,
      disabledFields: disabledFields
    })), /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
      "in": advanced
    }, /*#__PURE__*/_react["default"].createElement(Section, {
      title: t('retrofit.imap.advanced')
    }, /*#__PURE__*/_react["default"].createElement(AdvanceForm, {
      isLoading: isLoading,
      encryptionOptions: encryptionOptions
    }))), /*#__PURE__*/_react["default"].createElement(Section, {
      noborder: true,
      className: "mt-5"
    }, (0, _isFunction["default"])(action) ? action({
      disabled: isLoading || !isValid
    }) : action));
  });
};

var BaseForm = function BaseForm(_ref4) {
  var isLoading = _ref4.isLoading,
      disabledFields = _ref4.disabledFields;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  var isEmailAddressDisabled = !!disabledFields['emailAddress'];
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(InputGroup, {
    autoFocus: true,
    disabled: isEmailAddressDisabled,
    name: "emailAddress",
    type: "text",
    isLoading: isLoading
  }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
    autoFocus: isEmailAddressDisabled,
    autocomplete: "new-password",
    name: "password",
    type: "password",
    isLoading: isLoading
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-light mb-10"
  }, t("retrofit.imap.import.twoFactor.instruction")));
};

var AdvanceForm = function AdvanceForm(_ref5) {
  var isLoading = _ref5.isLoading,
      encryptionOptions = _ref5.encryptionOptions;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(InputGroup, {
    name: "username",
    type: "text",
    isLoading: isLoading
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement(InputGroup, {
    name: "imapHost",
    type: "text",
    className: "w-1/2",
    isLoading: isLoading
  }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
    name: "imapPort",
    type: "number",
    className: "w-1/4 px-3",
    isLoading: isLoading
  }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
    name: "imapEncryption",
    type: "select",
    className: "w-1/4",
    isLoading: isLoading,
    options: encryptionOptions.imap
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement(InputGroup, {
    name: "smtpHost",
    type: "text",
    className: "w-1/2",
    isLoading: isLoading
  }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
    name: "smtpPort",
    type: "number",
    className: "w-1/4 px-3",
    isLoading: isLoading
  }), /*#__PURE__*/_react["default"].createElement(InputGroup, {
    name: "smtpEncryption",
    type: "select",
    className: "w-1/4",
    isLoading: isLoading,
    options: encryptionOptions.smtp
  })));
};

var Section = function Section(_ref6) {
  var _ref6$noborder = _ref6.noborder,
      noborder = _ref6$noborder === void 0 ? false : _ref6$noborder,
      _ref6$title = _ref6.title,
      title = _ref6$title === void 0 ? '' : _ref6$title,
      _ref6$className = _ref6.className,
      className = _ref6$className === void 0 ? '' : _ref6$className,
      children = _ref6.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full flex justify-center",
    style: {
      height: 30
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-divider text-gray-light text-xs px-4 rounded-lg flex items-center"
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('border-2 px-5 pt-5', {
      'border-devider': !noborder,
      'border-transparent': noborder
    }),
    style: {
      marginTop: -15
    }
  }, children));
};

var PasswordInput = function PasswordInput(_ref7) {
  var name = _ref7.name,
      className = _ref7.className,
      disabled = _ref7.disabled,
      props = (0, _objectWithoutProperties2["default"])(_ref7, ["name", "className", "disabled"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, props, {
    name: name,
    className: (0, _classnames["default"])('pr-16', className),
    type: visible ? 'text' : 'password',
    disabled: disabled
  })), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "text-lg px-4 text-gray-light w-16 h-full absolute right-0 top-0 flex items-center justify-center",
    onClick: function onClick(e) {
      e.stopPropagation();
      setVisible(!visible);
    }
  }, visible ? /*#__PURE__*/_react["default"].createElement(_VisibilityOff["default"], {
    fontSize: "inherit"
  }) : /*#__PURE__*/_react["default"].createElement(_Visibility["default"], {
    fontSize: "inherit"
  })));
};

var EncryptionSelect = function EncryptionSelect(_ref8) {
  var name = _ref8.name,
      className = _ref8.className,
      disabled = _ref8.disabled,
      options = _ref8.options;
  return /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    name: name,
    disabled: disabled,
    className: className
  }, options.map(function (o) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: o.value,
      value: o.value
    }, o.label);
  }));
};

var inputComponents = {
  password: PasswordInput,
  select: EncryptionSelect,
  "default": _Input["default"]
};

var InputGroup = function InputGroup(_ref9) {
  var name = _ref9.name,
      type = _ref9.type,
      _ref9$className = _ref9.className,
      className = _ref9$className === void 0 ? '' : _ref9$className,
      _ref9$isLoading = _ref9.isLoading,
      isLoading = _ref9$isLoading === void 0 ? false : _ref9$isLoading,
      props = (0, _objectWithoutProperties2["default"])(_ref9, ["name", "type", "className", "isLoading"]);

  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  var Component = (0, _get["default"])(inputComponents, type, inputComponents["default"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'my-3 h-full')
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    htmlFor: name
  }, t("retrofit.imap.".concat(name, ".label"))), /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
    name: name,
    type: type,
    className: "w-full border-none",
    disabled: props.disabled || isLoading
  })), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
    name: name
  }));
};

var ButtonWithLoader = function ButtonWithLoader(_ref10) {
  var children = _ref10.children,
      _ref10$isLoading = _ref10.isLoading,
      isLoading = _ref10$isLoading === void 0 ? false : _ref10$isLoading,
      props = (0, _objectWithoutProperties2["default"])(_ref10, ["children", "isLoading"]);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], props, isLoading ? /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
    fullWidth: true,
    size: 24,
    color: "inherit"
  }) : children);
};

var ImportButton = function ImportButton(props) {
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation4.t;

  return /*#__PURE__*/_react["default"].createElement(ButtonWithLoader, (0, _extends2["default"])({}, props, {
    type: "submit",
    className: "w-56"
  }), t('button.import'));
};

exports.ImportButton = ImportButton;

var ReconnectButton = function ReconnectButton(props) {
  var _useTranslation5 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation5.t;

  return /*#__PURE__*/_react["default"].createElement(ButtonWithLoader, (0, _extends2["default"])({}, props, {
    type: "submit",
    className: "w-56"
  }), t('button.reconnect'));
};

exports.ReconnectButton = ReconnectButton;

function fixValueType(values) {
  return (0, _mapValues["default"])(values, function (val, key) {
    switch (key) {
      case 'imapEncryption':
      case 'smtpEncryption':
        var fixed = parseInt(val);
        return isNaN(fixed) ? INITIAL_VALUES[key] : fixed;

      default:
        return val;
    }
  });
}

var _default = IMAPForm;
exports["default"] = _default;
//# sourceMappingURL=IMAPForm.js.map